import React from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: { label: string; onClick?: () => void; href?: string };
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
}

export default function EmptyState({ icon, title, description, action, size = 'md', style }: EmptyStateProps) {
  const sizes = {
    sm: { wrapper: '80px', iconSize: '20px', titleSize: '11px', descSize: '10px' },
    md: { wrapper: '100px', iconSize: '24px', titleSize: '11px', descSize: '10px' },
    lg: { wrapper: '120px', iconSize: '28px', titleSize: '12px', descSize: '10px' },
  };
  const s = sizes[size];

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: s.wrapper, textAlign: 'center', ...style,
    }}>
      {icon && (
        <div style={{
          fontSize: s.iconSize, marginBottom: '16px', opacity: 0.25,
          filter: 'grayscale(1)',
        }}>
          {icon}
        </div>
      )}
      <div style={{
        fontSize: s.titleSize, fontWeight: 600,
        color: '#555', marginBottom: description ? '8px' : action ? '16px' : '0',
      }}>
        {title}
      </div>
      {description && (
        <div style={{
          fontSize: s.descSize,
          color: '#444',
          lineHeight: 1.6,
          maxWidth: '320px',
          marginBottom: action ? '20px' : '0',
        }}>
          {description}
        </div>
      )}
      {action && (
        action.href ? (
          <a href={action.href} style={{
            display: 'inline-block', padding: '4px 12px', height: '26px', borderRadius: 0,
            background: '#1e3a5f', border: '1px solid #3b82f6',
            color: '#3b82f6', fontSize: '10px', fontWeight: 700, cursor: 'pointer',
            textDecoration: 'none',
          }}>
            {action.label}
          </a>
        ) : (
          <button onClick={action.onClick} style={{
            padding: '4px 12px', height: '26px', borderRadius: 0,
            background: '#1e3a5f', border: '1px solid #3b82f6',
            color: '#3b82f6', fontSize: '10px', fontWeight: 700, cursor: 'pointer',
          }}>
            {action.label}
          </button>
        )
      )}
    </div>
  );
}
